export const Periode = [
  'DerniersTrenteJours',
  'MoisCourant',
  'MoisPrecedent',
  'AnneePrecedente',
  'AnneeCourante',
] as const

export type Periode = typeof Periode[number]

export const PeriodeLibelle: {
  [key in Periode]: string
} = {
  DerniersTrenteJours: 'Les 30 derniers jours',
  MoisCourant: 'Le mois courant',
  MoisPrecedent: 'Le mois précédent',
  AnneePrecedente: 'Année précédente',
  AnneeCourante: 'Année courante',
} as const

